import _ from 'lodash'

const camelCaseKeys = (node) => {
  if (_.isArray(node)) {
    return _.map(node, camelCaseKeys)
  }
  if (_.isPlainObject(node)) {
    return _.transform(node, (result, value, key) =>
      _.set(result, _.camelCase(key), _.isObjectLike(value) ? camelCaseKeys(value) : value),
    )
  }

  return node
}

export default camelCaseKeys
